// 仅处理 TDesign 官方整套 SVG sprite，不改变其他业务脚本。
const SPRITE_URL = /^https:\/\/tdesign\.gtimg\.com\/icon\/[\w.-]+\/fonts\/index\.js(?:[?#].*)?$/i

export default {
  jsLoader(code, url = '') {
    if (!code || !SPRITE_URL.test(url)) return code

    // 同版本的缓存参数不产生新副本，不同版本的地址仍保持独立。
    const key = encodeURIComponent(url.split(/[?#]/)[0])
    const selector = `svg[data-hx-tdesign-sprite-key="${key}"]`

    // 保护代码在子应用沙箱中执行。标记属于实际 SVG，而非主应用全局状态：
    // 其他子应用可独立加载，当前子应用 DOM 重建后也可以重新加载。
    return `
;(function () {
  function loadSpriteOnce() {
    if (document.querySelector(${JSON.stringify(selector)})) return;

${code}

    var symbol = document.querySelector('symbol[id="t-icon-close"]');
    var sprite = symbol && symbol.ownerSVGElement;
    if (sprite) {
      sprite.setAttribute('data-hx-tdesign-sprite-key', ${JSON.stringify(key)});
    }
  }

  if (document.body) {
    loadSpriteOnce();
  } else {
    document.addEventListener('DOMContentLoaded', loadSpriteOnce, { once: true });
  }
})();
`
  },
}
